import {Stack} from '@mui/material';
import {GridColDef, GridRenderEditCellParams, useGridApiContext} from '@mui/x-data-grid-pro';

import {Array} from '@utils/extensions/array.extension';
import {ColumnProps} from '@utils/table/columnTypes.table';

import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';

interface NumberColumnComponentProps extends GridRenderEditCellParams {
  inputColor?: (row: any) => string;
  readonly?: boolean;
}

const NumberColumnComponent = (props: NumberColumnComponentProps) => {
  const {id, field, formattedValue, inputColor, row, hasFocus, readonly} = props;

  const apiRef = useGridApiContext();

  return (
    <Stack flex={1}>
      <NumberTextFieldComponent
        readOnly={readonly ?? false}
        hasFocus={hasFocus}
        pattern={new RegExp(/^-?(\d*|\d+)[,.]?\d*$/)}
        size={formattedValue ?? 'small'}
        placeholder="-"
        handleChange={(newValue) => apiRef.current.setEditCellValue({id, field, value: newValue})}
        inputColor={inputColor?.(row)}
        value={formattedValue}/>
    </Stack>
  );
};

interface NumberColumnProps extends ColumnProps {
  disabled?: (row: any) => boolean;
  inputColor?: (row: any) => string;
  endAdornment?: (row: any) => JSX.Element;
  unitName?: (row: any) => JSX.Element;
}

export const COLUMN_TYPE_NUMBER = (props: NumberColumnProps): GridColDef => ({
  cellClassName: (params) => Array.mapNotNull([props.cellClassName?.(params)])?.join(' ') ?? '',
  field: props.field ?? '',
  headerName: props.label,
  minWidth: props.minWidth ?? 50,
  sortable: props.sortable ?? false,
  editable: props.editable ?? true,
  renderCell: (params) => {
    return (
      <Stack direction={props.unitName ? 'row' : 'column'}
             spacing={props.unitName ? 1 : 0}
             alignItems={props.unitName ? 'center' : undefined}
             flex={1}>
        <NumberTextFieldComponent
          readOnly
          pattern={new RegExp(/^-?(\d*|\d+)[,.]?\d*$/)}
          size={params.value ?? 'small'}
          placeholder="-"
          value={params.formattedValue}
          color={params.isEditable ? 'primary' : 'secondary'}
          endAdornment={props.endAdornment?.(params.row)}
          inputColor={props.inputColor?.(params.row)}/>

        {props.unitName?.(params.row)}
      </Stack>
    );
  },
  renderEditCell: (params) => {
    return (
      <NumberColumnComponent {...params} inputColor={props.inputColor}
                             readonly={props.disabled ? props.disabled(params.row) : false}/>
    );
  },
  valueSetter: props.valueSetter,
  valueGetter: props.valueGetter,
  valueFormatter: props.valueFormatter,
  width: props.width ?? 150,
});
